import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';
import { Link } from 'react-router-dom';

const BRAND_LOGO_WIDTH = 88;
const BRAND_LOGO_HEIGHT = 31;

export const PriceInfoRow = styled.span`
  display: none;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  padding-bottom: 0;

  .pj-ui-price-label {
    color: $text-color;
    padding-top: 1rem;
    padding-right: 1rem;
  }

  .pj-ui-price-notice {
    color: $text-color;
  }

  ${media.smallOnly`
    display: flex;
  `}
`;

export const RecommendedRetailerExpansion = styled.div`
  a {
    display: flex;
    align-items: center;
  }
  img {
    margin-right: 0.5rem;
    width: ${BRAND_LOGO_WIDTH}px;
    height: ${BRAND_LOGO_HEIGHT}px;
  }
`;

export const StoreInfoRow = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: space-between;

  > div {
    flex: 0 0 48%;
    .sentiment-badge--text > span {
      display: block;
      margin-left: 0;
    }
  }
`;

export const StoreInfoRowItem = styled.div`
  margin-bottom: 1rem;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const StoreInfoList = styled.ul`
  list-style-position: inside;
`;

export const StoreInfoText = styled.li`
  &:last-of-type {
    margin-bottom: 1rem;
  }
  color: ${p => p.theme.lines.secondary};
`;

export const StoreInfoTextInner = styled.span`
  color: ${p => p.theme.text.primary};
`;

export const StoreInfoLink = styled(Link)`
  display: block;
  text-decoration: underline;
  margin-bottom: 1rem;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export default {
  RecommendedRetailerExpansion,
  StoreInfoRow,
  StoreInfoText,
  StoreInfoLink,
};
